var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 52,
    viewBox: "0 0 113 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_3497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.57 25.99L42.25 0.660034V51.32L70.57 25.99Z",
    fill: "#A0DEB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.82 25.99L84.5 0.660034V51.32L112.82 25.99Z",
    fill: "#66C67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.33 25.99L0 0.660034V51.32L28.33 25.99Z",
    fill: "#66C67F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_3497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.82,
    height: 50.66,
    fill: "white",
    transform: "translate(0 0.660034)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow_2.09636be7274908a816a94488a2ee5147.svg";
export { ForwardRef as ReactComponent };